/**
 * @generated SignedSource<<9c7dc573a7fcaa6202100cfff82de616>>
 * @relayHash 0aa2cd372d50977766be55729cd7417e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3a652340b68ed0805e1873b59a6383d4bb2ad5ac253f84f74d38978500eaad64

import type { ConcreteRequest } from 'relay-runtime';
export type CcpPricingType = "EXTERNAL" | "FREE" | "LIMITED_FREE" | "PAID" | "%future added value";
export type LoomMeetingOneClickActionConfluenceContentType = "DATABASE" | "LIVE_DOC" | "SLIDES" | "WHITEBOARD" | "%future added value";
export type LoomMeetingOneClickActionStatus = "ACCEPTED" | "DISMISSED" | "PENDING" | "%future added value";
export type LoomMeetingOneClickActionType = "CONFLUENCE" | "JIRA" | "MESSAGE" | "%future added value";
export type useMeetingsQuery$variables = {
  cloudId: string;
  cloudIds: ReadonlyArray<string>;
  rangeEnd?: string | null;
  rangeStart?: string | null;
  siteAri: string;
};
export type useMeetingsQuery$data = {
  readonly loom_connectedCalendars: ReadonlyArray<{
    readonly guid: string;
  } | null> | null;
  readonly loom_recordedMeetings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly inviteeAris: ReadonlyArray<string | null> | null;
        readonly invitees: ReadonlyArray<{
          readonly accountId: string;
          readonly name: string;
          readonly picture: AGG$URL;
        } | null> | null;
        readonly oneClickActions: ReadonlyArray<{
          readonly action: string | null;
          readonly confluenceContentType: LoomMeetingOneClickActionConfluenceContentType | null;
          readonly id: string;
          readonly status: LoomMeetingOneClickActionStatus | null;
          readonly timestampSeconds: number | null;
          readonly type: LoomMeetingOneClickActionType | null;
        } | null> | null;
        readonly recorder: {
          readonly accountId: string;
          readonly name: string;
          readonly picture: AGG$URL;
        } | null;
        readonly recorderId: string | null;
        readonly recurring: boolean | null;
        readonly startsAt: string | null;
        readonly title: string;
        readonly video: {
          readonly id: string;
          readonly isMeeting: boolean | null;
          readonly meetingAri: string | null;
          readonly shortSummary: string | null;
          readonly url: string;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly loom_settings: {
    readonly meetingRecordingsAvailable: boolean | null;
  } | null;
  readonly tenantContexts: ReadonlyArray<{
    readonly confluenceEntitlementInfo: {
      readonly entitlement?: {
        readonly offering: {
          readonly pricingType: CcpPricingType | null;
        } | null;
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlement: {
            readonly offering: {
              readonly pricingType: CcpPricingType | null;
            } | null;
          } | null;
          readonly relationshipType: string | null;
        } | null> | null;
      } | null;
    } | null;
    readonly jiraEntitlementInfo: {
      readonly entitlement?: {
        readonly offering: {
          readonly pricingType: CcpPricingType | null;
        } | null;
      } | null;
    } | null;
  } | null> | null;
};
export type useMeetingsQuery = {
  response: useMeetingsQuery$data;
  variables: useMeetingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rangeEnd"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rangeStart"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteAri"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudIds",
    "variableName": "cloudIds"
  }
],
v6 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "confluence.ondemand"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "relationshipType"
},
v8 = {
  "kind": "ScalarField",
  "name": "pricingType"
},
v9 = {
  "concreteType": "CcpOffering",
  "kind": "LinkedField",
  "name": "offering",
  "plural": false,
  "selections": [
    (v8/*: any*/)
  ]
},
v10 = {
  "concreteType": "CcpEntitlement",
  "kind": "LinkedField",
  "name": "entitlement",
  "plural": false,
  "selections": [
    (v9/*: any*/)
  ]
},
v11 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "jira-software.ondemand"
  }
],
v12 = [
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "cloudId"
  }
],
v13 = {
  "args": (v12/*: any*/),
  "concreteType": "LoomSettings",
  "kind": "LinkedField",
  "name": "loom_settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "meetingRecordingsAvailable"
    }
  ]
},
v14 = {
  "args": (v12/*: any*/),
  "concreteType": "LoomConnectedCalendar",
  "kind": "LinkedField",
  "name": "loom_connectedCalendars",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "guid"
    }
  ]
},
v15 = [
  {
    "kind": "Literal",
    "name": "order",
    "value": "DESC"
  },
  {
    "kind": "Variable",
    "name": "rangeEnd",
    "variableName": "rangeEnd"
  },
  {
    "kind": "Variable",
    "name": "rangeStart",
    "variableName": "rangeStart"
  },
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "siteAri"
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = {
  "kind": "ScalarField",
  "name": "title"
},
v18 = {
  "kind": "ScalarField",
  "name": "startsAt"
},
v19 = {
  "kind": "ScalarField",
  "name": "recorderId"
},
v20 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v21 = {
  "kind": "ScalarField",
  "name": "name"
},
v22 = {
  "kind": "ScalarField",
  "name": "picture"
},
v23 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "inviteeAris"
},
v25 = {
  "concreteType": "LoomVideo",
  "kind": "LinkedField",
  "name": "video",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "isMeeting"
    },
    {
      "kind": "ScalarField",
      "name": "meetingAri"
    },
    {
      "kind": "ScalarField",
      "name": "shortSummary"
    }
  ]
},
v26 = {
  "concreteType": "LoomMeetingOneClickAction",
  "kind": "LinkedField",
  "name": "oneClickActions",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    {
      "kind": "ScalarField",
      "name": "action"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "confluenceContentType"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "timestampSeconds"
    }
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "recurring"
},
v28 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v29 = {
  "concreteType": "CcpOffering",
  "kind": "LinkedField",
  "name": "offering",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v16/*: any*/)
  ]
},
v30 = {
  "concreteType": "CcpEntitlement",
  "kind": "LinkedField",
  "name": "entitlement",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v16/*: any*/)
  ]
},
v31 = [
  (v28/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useMeetingsQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "alias": "confluenceEntitlementInfo",
            "args": (v6/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          },
          {
            "alias": "jiraEntitlementInfo",
            "args": (v11/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/)
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
          }
        ]
      },
      (v13/*: any*/),
      (v14/*: any*/),
      {
        "args": (v15/*: any*/),
        "concreteType": "LoomMeetingConnection",
        "kind": "LinkedField",
        "name": "loom_recordedMeetings",
        "plural": false,
        "selections": [
          {
            "concreteType": "LoomMeetingEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "LoomMeeting",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "recorder",
                    "plural": false,
                    "selections": (v23/*: any*/)
                  },
                  (v24/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "invitees",
                    "plural": true,
                    "selections": (v23/*: any*/)
                  },
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useMeetingsQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "alias": "confluenceEntitlementInfo",
            "args": (v6/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v30/*: any*/)
                        ]
                      },
                      (v29/*: any*/),
                      (v16/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          },
          {
            "alias": "jiraEntitlementInfo",
            "args": (v11/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v30/*: any*/)
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
          }
        ]
      },
      (v13/*: any*/),
      (v14/*: any*/),
      {
        "args": (v15/*: any*/),
        "concreteType": "LoomMeetingConnection",
        "kind": "LinkedField",
        "name": "loom_recordedMeetings",
        "plural": false,
        "selections": [
          {
            "concreteType": "LoomMeetingEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "LoomMeeting",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "recorder",
                    "plural": false,
                    "selections": (v31/*: any*/)
                  },
                  (v24/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "invitees",
                    "plural": true,
                    "selections": (v31/*: any*/)
                  },
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0aa2cd372d50977766be55729cd7417e",
    "id": "3a652340b68ed0805e1873b59a6383d4bb2ad5ac253f84f74d38978500eaad64",
    "metadata": {},
    "name": "useMeetingsQuery",
    "operationKind": "query",
    "text": "query useMeetingsQuery($cloudId:ID!,$cloudIds:[ID!]!,$siteAri:ID!,$rangeStart:String,$rangeEnd:String){tenantContexts(cloudIds:$cloudIds){confluenceEntitlementInfo:entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{relatesFromEntitlements{relationshipType,entitlement{offering{pricingType,id},id}},offering{pricingType,id},id}}},jiraEntitlementInfo:entitlementInfo(hamsProductKey:\"jira-software.ondemand\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{offering{pricingType,id},id}}}},loom_settings(siteId:$cloudId){meetingRecordingsAvailable},loom_connectedCalendars(siteId:$cloudId){guid},loom_recordedMeetings(siteId:$siteAri,rangeStart:$rangeStart,rangeEnd:$rangeEnd,order:DESC){edges{node{id,title,startsAt,recorderId,recorder{__typename,accountId,name,picture,id},inviteeAris,invitees{__typename,accountId,name,picture,id},video{id,url,isMeeting,meetingAri,shortSummary},oneClickActions{id,action,type,confluenceContentType,status,timestampSeconds},recurring}}}}"
  }
};
})();

(node as any).hash = "f7f434f94f9e4ebc90a3406cdad23741";

export default node;
